'use client';

import Script from 'next/script';

export type VerifyCallbackType = (arg: boolean) => void;

interface ReCaptchaProps {
  verifyCallback: VerifyCallbackType;
}

const ReCaptcha = ({ verifyCallback }: ReCaptchaProps) => {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
  const recaptchaID = 'tc-grecaptcha';

  const handleVerify = async (token: string) => {
    const res = await fetch('/builder-home-rebrand/api/grecaptcha/siteverify', {
      method: 'POST',
      body: JSON.stringify({
        token: token,
      }),
    });
    const { success } = await res.json();
    verifyCallback(success);
  };

  const fixGrecaptchaA11yCompliance = () => {
    // Google reCaptcha is not WCAG compliant and has a missing label for a hidden textarea.
    // Some older screen-readers will announce the textarea, this fix removes it from the accessibility tree.
    let checkCount = 0;
    const checkIsRendered = setInterval(() => {
      checkCount++;
      const element = document.getElementById('g-recaptcha-response');
      if (element) {
        element.setAttribute('aria-hidden', 'true');
        return clearInterval(checkIsRendered);
      }
      if (checkCount > 4) {
        // Give up after 5 failed attempts
        clearInterval(checkIsRendered);
      }
    }, 500);
  };

  const handleOnLoad = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.render(recaptchaID, {
        sitekey: siteKey,
        theme: 'light',
        callback: handleVerify,
      });
      fixGrecaptchaA11yCompliance();
    });
  };

  return (
    <>
      <Script src="https://www.google.com/recaptcha/api.js?render=explicit" onLoad={handleOnLoad} />
      <div id={recaptchaID} data-sitekey={siteKey}></div>
    </>
  );
};

export default ReCaptcha;
